import { Fragment } from "react";
import { useIntl } from "react-intl";
import { LabelLangString } from "component/LabelLang/label-lang";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";

function SubjectNav({
  dir,
  currentLocale,
  mainId,
  subSubjectId,
  indicatorIdData,
  mainList,
  subSubjectsListWithMainId,
  indicatorsList,
  indicatorList,
  indicatorRefs,
  onMainSubjectChange,
  onSubSubjectChange,
  onIndicatorChange,
  onIndicatorRadioChange,
  className,
}) {
  const intl = useIntl();
  const lineClass = dir === "rtl" ? "r-line" : "l-line";
  const hasIndicators =
    indicatorList && Object.keys(indicatorList).length > 0;
  const Wrapper = className ? "div" : Fragment;
  const wrapperProps = className ? { className } : {};

  return (
    <Wrapper {...wrapperProps}>
      <div className={`main-button ${lineClass}`}>
        <select
          name="main-subject"
          id="main-subject"
          onChange={(e) => onMainSubjectChange(e.target.value)}
          defaultValue={mainId}
        >
          {mainList?.data?.data?.map((el, i) => (
            <option
              key={i}
              value={el.id}
              defaultChecked={el.id === mainId}
              title={LabelLangString({
                id: "name",
                currentLocale,
                defaultValue: el.name,
                translations: el.translations,
              })}
            >
              {LabelLangString({
                id: "name",
                currentLocale,
                defaultValue: el.name,
                translations: el.translations,
              })}
            </option>
          ))}
        </select>
      </div>

      <div className={`second-button ${lineClass}`}>
        {subSubjectsListWithMainId?.data?.data &&
        Object.keys(subSubjectsListWithMainId.data.data).length > 0 ? (
          <select
            name="second-subject"
            id="second-subject"
            onChange={(e) => onSubSubjectChange(e.target.value)}
            defaultValue={subSubjectId}
          >
            {subSubjectsListWithMainId.data.data.map((el, i) => (
              <option
                key={i}
                value={el.id}
                defaultChecked={el.id === subSubjectId}
                title={LabelLangString({
                  id: "title",
                  currentLocale,
                  defaultValue: el.title,
                  translations: el.subjectTranslations,
                })}
              >
                {LabelLangString({
                  id: "title",
                  currentLocale,
                  defaultValue: el.title,
                  translations: el.subjectTranslations,
                })}
              </option>
            ))}
          </select>
        ) : (
          <button type="button">
            {intl.formatMessage({ id: "data-not-found" })}
          </button>
        )}
      </div>

      <form
        className="radio-box"
        onChange={(e) => onIndicatorChange(e.target.value)}
      >
        {indicatorsList.isLoading || indicatorsList.error ? (
          <div className="text-center" dir="ltr">
            <h5>{intl.formatMessage({ id: "loading..." })}</h5>
          </div>
        ) : hasIndicators ? (
          indicatorList.map((el) => (
            <div
              key={el.indicatorId}
              ref={(element) => {
                if (indicatorRefs) {
                  indicatorRefs.current[el?.indicatorId] = element;
                }
              }}
              className={`item ${lineClass}`}
            >
              <input
                type="radio"
                name={`radio-${el.name}-${el.indicatorId}`}
                id={`radio-${el.name}-${el.indicatorId}`}
                value={el.indicatorId}
                checked={+indicatorIdData === el.indicatorId}
                onChange={() => onIndicatorRadioChange(el.indicatorId)}
              />
              <label
                htmlFor={`radio-${el.name}-${el.indicatorId}`}
                title={LabelLangString({
                  id: "name",
                  currentLocale,
                  defaultValue: el.name,
                  translations: el.indicatorTranslations,
                })}
              >
                {LabelLangString({
                  id: "name",
                  currentLocale,
                  defaultValue: el.name,
                  translations: el.indicatorTranslations,
                })}
              </label>
            </div>
          ))
        ) : (
          <div className={`mt-3 ${dir === "rtl" ? "me-3" : "ms-3"}`}>
            <DataNotFound />
          </div>
        )}
      </form>
    </Wrapper>
  );
}

export default SubjectNav;
